export const bgBlue = "#45404E";
export const bgWhite = "#fff";
export const bgLight = "#e9e9ea";
export const bgLighter = "#ebf1f6";

export const disabledElementDark = "#3e3a46";
export const disabledElementLight = "#c8ccd0";
// export const bgGray = "#979797";
export const bgGray = "#fff";

export const textWhite = "#FFFFFF";

export const vsiGreen = "#3fb83d";
export const vsiRed = "#e10000";
export const vsiNavy = "#303365";
export const vsiTitleTextColorDark = "#d2d2d2";
export const vsiTitleTextColorLight = "#232323";

export const dark = {
  type: "dark",
  bgColor: "#2A2730",
  chartBgColor: "#2A2730",
  cardBgColor: '#212529',
  altBgColor: bgBlue,
  sideBgColor: bgBlue,
  navItemBg: bgBlue,
  disabledBtnColor: disabledElementDark,
  navItemBgActive: "#212529",
  textColor: textWhite,
  titleTextColor: vsiTitleTextColorDark,
  oppTextColor: "black",
  bootstrapTextColor: "white",
  sideColor: textWhite,
  navBorderBgColor: bgGray,
  vsiPupil: vsiGreen,
  vsiIris: textWhite,
  reportBtnBg: vsiNavy,
  reportBtnIconColor: vsiGreen,
  legendBackground: 'black',
  selectorBg: bgBlue,
  selectorBgEnabled: disabledElementDark,
  selectedOptionBg: bgBlue,
  contrastColors: [
    '#ff8d02', // (Orange)
    '#B0EA3B', // (Lime Green)
    '#099c9d', // (Teal)
    '#CE00D1', // (Magenta)
    '#004577', // (Dark Blue)
    '#865aa5', // (Purple)
    '#990000', // (Dark Red)
    '#0066b5', // (Dark Cyan)
    '#999999', // (Dark Gray)
  ],
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
};

export const light = {
  type: "light",
  bgColor: 'rgb(248,249,250)',
  chartBgColor: 'rgb(248,249,250)',
  cardBgColor: bgWhite,
  altBgColor: bgLight,
  sideBgColor: bgLight,
  navItemBg: bgLight,
  disabledBtnColor: disabledElementLight,
  navItemBgActive: bgWhite,
  textColor: "black",
  titleTextColor: vsiTitleTextColorLight,
  oppTextColor: textWhite,
  bootstrapTextColor: "black",
  sideColor: "black",
  navBorderBgColor: bgLight,
  vsiPupil: "#0000d7",
  vsiIris: vsiNavy,
  reportBtnBg: vsiGreen,
  reportBtnIconColor: "black",
  legendBackground: 'white',
  selectorBg: bgWhite,
  selectorBgEnabled: bgLighter,
  selectedOptionBg: bgLight,
  contrastColors: [
    '#4897ff', // (Blue)
    '#ed5690', // (Pink)
    '#fa6375', // (Red)
    '#31ff3a', // (Green)
    '#ffba00', // (Yellow)
    '#57a55a', // (Green)
    '#006699', // (Dark Cyan)
    '#ff6699', // (Light Pink)
    '#666666', // (Light Gray)
  ],
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
};

const theme = {
  light,
  dark,
};

export default theme;
